import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Eye, Trash2, Save } from "lucide-react";
import { RELAZIONI, STILI_RISPOSTA, INITIAL_FORM } from "./SchedaConstants";

export const SchedaListView = ({ episodes, onBack, onNewScheda, onViewSummary, onDelete }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-3">
      <Button variant="ghost" size="sm" onClick={onBack} className="rounded-full">
        <ArrowLeft className="w-4 h-4 mr-1" /> Indietro
      </Button>
    </div>

    <div className="text-center space-y-4">
      <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-amber-600 rounded-full flex items-center justify-center mx-auto">
        <span className="text-4xl">{"\u{1F4DD}"}</span>
      </div>
      <h1 className="text-2xl font-bold text-gray-800">Scheda Episodio</h1>
      <p className="text-gray-600 text-sm max-w-md mx-auto">
        Compila questa scheda dopo una situazione problematica o un conflitto, 
        entro 30-60 minuti dall'episodio.
      </p>
    </div>

    <Button 
      onClick={onNewScheda}
      className="w-full rounded-xl bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700"
      size="lg"
    >
      <Save className="w-5 h-5 mr-2" /> Nuova Scheda
    </Button>

    {episodes.length > 0 ? (
      <div className="space-y-3">
        <h3 className="font-semibold text-gray-700">Schede salvate ({episodes.length})</h3>
        {episodes.map(ep => (
          <Card key={ep.episode_id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0 cursor-pointer" onClick={() => onViewSummary(ep)}>
                  <div className="flex items-center gap-2 mb-1">
                    <Badge variant="outline" className="text-xs">
                      {new Date(ep.data).toLocaleDateString('it-IT')}
                    </Badge>
                    {ep.relazione && (
                      <Badge variant="secondary" className="text-xs">
                        {RELAZIONI.find(r => r.id === ep.relazione)?.label || ep.relazione}
                      </Badge>
                    )}
                    {ep.mioStile && (
                      <Badge className={`text-xs ${STILI_RISPOSTA.find(s => s.id === ep.mioStile)?.color}`}>
                        {ep.mioStile}
                      </Badge>
                    )}
                  </div>
                  <p className="text-sm text-gray-800 line-clamp-2">{ep.descrizione || ep.tema || "Nessuna descrizione"}</p>
                  {ep.conChi && <p className="text-xs text-gray-500 mt-1">Con: {ep.conChi}</p>}
                </div>
                <div className="flex gap-1 ml-2">
                  <Button variant="ghost" size="sm" onClick={() => onViewSummary(ep)} title="Visualizza">
                    <Eye className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => onDelete(ep.episode_id)} className="text-red-500 hover:text-red-700" title="Elimina">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    ) : (
      <Card className="border-dashed">
        <CardContent className="p-8 text-center">
          <p className="text-gray-500">Nessuna scheda salvata</p>
          <p className="text-sm text-gray-400 mt-1">Crea la tua prima scheda per analizzare un episodio</p>
        </CardContent>
      </Card>
    )}
  </div>
);
